<template>
  <div class="my-table">
    <el-table :data="tableData" border height="100%">
      <el-table-column
        v-for="(item, index) of tableColumns"
        :key="index"
        align="center"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
      >
        <template slot-scope="scope">
          <div v-if="item.slotName">
            <slot :name="item.slotName" :data="scope.row"></slot>
          </div>
          <div v-else-if="item.type">
            {{ scope.row.index + 1 }}
          </div>
          <div v-else>
            {{ scope.row[item.prop] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="showpagination"
      background
      :layout="pageConfig.layout"
      :page-sizes="pageConfig.pageSizes"
      :total="pageConfig.total"
      :page-size.sync="pageConfig.pageSize"
      :current-page.sync="pageConfig.currentPage"
      @current-change="getTableList()"
      @size-change="getTableList()"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "MyTable",
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableColumns: {
      type: Array,
      default: () => []
    },
    pageConfig: {},
    showpagination: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getTableList() {
      this.$emit("changeSize");
    }
  }
};
</script>
<style lang="less" scoped>
.my-table {
  height: calc(100% - 111px);
}
@media screen and (max-width: 700px) {
  .my-table {
    max-width: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyTable.vue